module.exports = __webpack_public_path__ + "img/check.749be189.svg";